
import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { RiDeleteBin6Fill, } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import AddButton from "../../../Components/CommonComponent/Button/AddButton";
import Pagination, { usePagination } from "../../../Components/CommonComponent/Pgination/pagination";
import AddPayment from "./AddPayment";
import DeleteDataModal from "../../../Components/CommonComponent/Modals/DeleteDataModal";
import { CommonContext } from "../../../App";
import { useContext } from "react";
import { NavLink, useLocation } from "react-router";
import { IoArrowUndoSharp } from "react-icons/io5";
import api from "../../../services/api";
import LoadingSpinner from "../../../Components/CommonComponent/loadingSpiner/LoadingSpinner";


export default function PaymentStructureTable() {
  const { t } = useTranslation();
  const [managers, setManagers] = useState({ allData: [], pagination: { totalRecords: 0 } });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);

  const [isAddPaymentModalOpen, setIsAddPaymentModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [selectedSubGroup, setSelectedSubGroup] = useState("");
  const [selectedLedger, setSelectedLedger] = useState("");
  const [groupName, setGroupName] = useState("");
  const [groupId, setGroupId] = useState("");
  const [groupType, setGroupType] = useState("");
  const [name, setName] = useState("");
  const [nameInHindi, setNameInHindi] = useState("");
  const [typeValidation, setTypeValidation] = useState(false);
  const [subGroupValidation, setSubGroupValidation] = useState(false);
  const [selectGroupValidation, setSelectGroupValidation] = useState(false);
  
  // Track IDs for save operation
  const [selectedSubGroupId, setSelectedSubGroupId] = useState("");
  const [selectedLedgerId, setSelectedLedgerId] = useState("");
  
  const { branchId } = useContext(CommonContext);
  const storedLang = JSON.parse(localStorage.getItem("second_language"));
  const language = storedLang?.language || "en";
  const [paymentData, setPaymentData] = useState({
    allData: [],
    pagination: { totalRecords: 0 }
  });
  const [defaultId, setDefaultId] = useState(null);
  const location = useLocation();
  const { comeBack } = location.state || {};

  const {
    currentPage,
    itemsPerPage,
    handlePageChange,
    handleItemsPerPageChange,
    getPaginatedData,
  } = usePagination(10);

  const paginationData = getPaginatedData(paymentData);

  useEffect(() => {
    if (branchId) {
      fetchPaymentType();
    }
  }, [currentPage, itemsPerPage, branchId]);

  const fetchPaymentType = async () => {
    try {
      setLoading(true);
      const res = await api.get(
        `payment-structure/get-all?page=${currentPage}&limit=${itemsPerPage}&branchId=${branchId}`
      );
      if (res.data.success) {
        setPaymentData({
          allData: res.data.data,
          pagination: res.data.pagination,
        });

        const defaultItem = res.data.data.find(item => item.is_default === 1);
        setDefaultId(defaultItem?.id || null);
      }
    } catch (err) {
      toast.error("Error fetching payment structures");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (item) => {
    try {
      const res = await api.post(`payment-structure/delete?id=${item.id}`,{ branchId });
      if (res.data.success) {
        toast.success("payment type deleted");
        fetchPaymentType();
      }
    } catch {
      toast.error("Failed to delete payment type");
    } finally {
      setModalDelete(false);
      setSelectedManager(null);
    }
  };

  const handleStatusChange = async (id, active) => {
    setManagers((prev) => ({
      ...prev, 
      allData: prev.allData.map((m) =>
        m.id === id ? { ...m, active } : m
      ),
    }));

    try {
      const res = await api.post(`payment-structure/update-status?id=${id}`, { active,branchId });
      toast.success(res?.data?.message || "Status updated");
      fetchPaymentType();
    } catch {
      toast.error("Failed to update status");
      setManagers(prev => ({
        ...prev,
        allData: prev.allData.map(m =>
          m.id === id ? { ...m, active: active === 1 ? 0 : 1 } : m
        ),
      }));
    }
  };

  const handleDefaultChange = async (id) => {
    setDefaultId(id);

    setPaymentData(prev => ({
      ...prev,
      allData: prev.allData.map(item => ({
        ...item,
        is_default: item.id === id ? 1 : 0
      }))
    }));

    try {
      const res = await api.post(`payment-structure/update-default?id=${id}`, { branchId });
      toast.success(res?.data?.message || "Default updated");
      fetchPaymentType();
    } catch (error) {
      toast.error("Failed to update default");
      fetchPaymentType();
    }
  };

  // Handle data refresh notifications from AddPayment and capture IDs
  const handleDataRefresh = (refreshData) => {
    console.log('Data refreshed in AddPayment:', refreshData.type);
    
    if (refreshData.type === 'subgroupSelected') {
      setSelectedSubGroupId(refreshData.data.id);
    } else if (refreshData.type === 'ledgerSelected') {
      setSelectedLedgerId(refreshData.data.id);
    }
  };

  return (
    <div className="py-2 flex justify-center">
      <div className="w-full flex flex-col">
        <div>
          <NavLink
            to={comeBack ? comeBack : "/web-setting"}
            title="Back to groups table"
            className="border inline-block p-1 px-2 text-theme-headerBg rounded hover:bg-theme-headerBg hover:text-theme-color cursor-pointer"
          >
            <IoArrowUndoSharp />
          </NavLink>
        </div>

        <div className="flex justify-between items-center py-[2px] bg-theme-headerBg px-2 text-theme-color">
          <div className="text-sm font-medium">{t('payamentAccount')} </div>
          <AddButton text={t("add")} onClick={() => setIsAddPaymentModalOpen(true)} />
        </div>

        {loading ? (
          <div className="flex justify-center items-center w-full py-12">
            <LoadingSpinner size={70} color="#be8024" />
          </div>
        ) : paymentData.allData && paymentData.allData.length === 0 ? (
          <p className="text-center text-gray-500 italic py-4">{t('noDataAvailable')} </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg text-sm">
                  <th className="border-b px-1 text-center">{t("srNumber")}</th>
                  <th className="border-b py-[2px] px-1">{t("name")}</th>
                  <th className="border-b px-1">{t("accountName")}</th>
                  <th className="border-b px-1">{t("type&Group")}</th>
                  <th className="border-b px-1 text-center">{t("default")}</th>
                  <th className="border-b px-1 text-center">{t("status")}</th>
                  <th className="border-b px-1 text-center">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {paymentData.allData.map((item, i) => (
                  <tr key={item.id} className="text-sm bg-theme-tableBg hover:bg-theme-tableHoverColor">
                    <td className="border-b px-1 text-center">
                      {(currentPage - 1) * itemsPerPage + i + 1}
                    </td>
                    <td className="border-b py-[2px] px-1 capitalize">
                      {item.name} {language !== "en" && item.name_in_hindi && ` ( ${item.name_in_hindi} )`}
                    </td>
                    <td className="border-b px-1 capitalize">{item.ledgerName}</td>
                    <td className="border-b px-1">
                      {item.type}{item.type && "/"}{item.groupName}{item.groupName && "/"}{item.subGroupName}
                    </td>
                    <td className="border px-1 text-center">
                      <input
                        type="checkbox"
                        checked={item.is_default === 1}
                        onChange={() => handleDefaultChange(item.id)}
                        className="w-4 h-4 cursor-pointer accent-theme-headerBg"
                      />
                    </td>
                    <td className="border px-1 text-center">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item.is_active === 1}
                          onChange={() => handleStatusChange(item.id, item.is_active === 1 ? 0 : 1)}
                        />
                        <div className={`w-12 h-5 mt-1 rounded-full transition-colors duration-300
                          ${item.is_active === 1 ? "bg-green-500" : "bg-red-500"}`}
                        ></div>
                        <div className={`absolute mt-1 top-0.5 w-4 h-4 bg-white rounded-full shadow-md transition-transform duration-300
                          ${item.is_active === 1 ? "translate-x-7" : "translate-x-1"}`}
                        ></div>
                      </label>
                    </td>
                    <td className="border px-1 text-center">
                      <div className="flex justify-center gap-2">
                        <FaEdit
                          className="cursor-pointer hover:text-theme-btnBg"
                          title="Edit manager"
                          onClick={() => {
                            setSelectedManager(item);
                            setName(item.name || "");
                            setNameInHindi(item.name_in_hindi || "");
                            setSelectedType(item.type || "");
                            setGroupName(item.groupName || "");
                            setGroupId(item.groupId || "");
                            setSelectedSubGroup(item.subGroupName || "");
                            setSelectedLedger(item.ledgerName || "");
                            setGroupType(item.type || "");
                            setIsAddPaymentModalOpen(true);
                          }}
                        />
                        <RiDeleteBin6Fill
                          className="text-red-700 cursor-pointer hover:text-red-800"
                          title="Delete manager"
                          onClick={() => {
                            setSelectedManager(item);
                            setModalDelete(true);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Pagination
              data={paymentData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              itemsPerPageOptions={[10, 20, 50]}
              showPageInfo
            />
          </div>
        )}
      </div>

      {/* Add Payment Modal - Now handles its own data fetching */}
      {isAddPaymentModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[100]">
          <AddPayment
            name={name}
            nameInHindi={nameInHindi}
            setNameInHindi={setNameInHindi}
            setName={setName}
            subGroupValidation={subGroupValidation}
            groupName={groupName}
            setGroupName={setGroupName}
            groupId={groupId}
            setGroupId={setGroupId}
            setSelectGroupValidation={setSelectGroupValidation}
            selectGroupValidation={selectGroupValidation}
            groupType={groupType}
            setGroupType={setGroupType}
            handleGroupSelect={() => { }}
            handleSubGroupCancel={() => {
              setIsAddPaymentModalOpen(false);
              setSelectedManager(null);
              setSelectedType("");
              setGroupName("");
              setGroupId("");
              setSelectedSubGroup("");
              setSelectedLedger("");
              setName("");
              setNameInHindi("");
              setGroupType("");
              setSelectedSubGroupId("");
              setSelectedLedgerId("");
              setTypeValidation(false);
              setSubGroupValidation(false);
              setSelectGroupValidation(false);
            }}
            handleSave={async (childData) => {
               const finalLedgerId = childData?.ledgerId || selectedLedgerId;
              if (!selectedType) {
                setTypeValidation(true);
                return;
              }
              if (!groupName) {
                setSelectGroupValidation(true);
                return;
              }
              if (!name) {
                setSubGroupValidation(true);
                return;
              }

              try {
                const payload = {
                  name: name,
                  nameInHindi: nameInHindi,
                  type: selectedType,
                  groupId: groupId,
                  subGroupId: selectedSubGroupId || null,
                  ledgerId: finalLedgerId || null,
                  branchId
                };

                const url = selectedManager
                  ? `payment-structure/update?id=${selectedManager.id}`
                  : `payment-structure/create`;

                const res = await api.post(url, payload);
                if (res.data.success) {
                  toast.success(selectedManager ? "Payment structure updated successfully!" : "Payment structure added successfully!");
                  setIsAddPaymentModalOpen(false);
                  setSelectedManager(null);
                  fetchPaymentType();
                  
                  // Reset all states
                  setName("");
                  setNameInHindi("");
                  setSelectedType("");
                  setGroupName("");
                  setGroupId("");
                  setSelectedSubGroup("");
                  setSelectedLedger("");
                  setGroupType("");
                  setSelectedSubGroupId("");
                  setSelectedLedgerId("");
                  setTypeValidation(false);
                  setSubGroupValidation(false);
                  setSelectGroupValidation(false);
                }
              } catch (error) {
                toast.error(error?.response?.data?.message || "Failed to save payment structure");
              }
            }}
            loading={loading}
            setLoading={setLoading}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            selectedSubGroup={selectedSubGroup}
            setSelectedSubGroup={setSelectedSubGroup}
            selectedLedger={selectedLedger}
            setSelectedLedger={setSelectedLedger}
            typeValidation={typeValidation}
            onDataRefresh={handleDataRefresh} // Optional callback
          />
        </div>
      )}

      {/* Delete Modal */}
      {modalDelete && (
        <DeleteDataModal
          selectedLedger={selectedManager}
          handleDeleteModalClose={() => {
            setModalDelete(false);
            setSelectedManager(null);
          }}
          handleDeleteLedgerApi={handleDelete}
        />
      )}
    </div>
  );
}





















// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import AddButton from "../../../Components/CommonComponent/Button/AddButton";
// import Pagination, { usePagination } from "../../../Components/CommonComponent/Pgination/pagination";
// import AddPayment from "./AddPayment";
// import DeleteDataModal from "../../../Components/CommonComponent/Modals/DeleteDataModal";
// import { CommonContext } from "../../../App";
// import { FaEdit } from "react-icons/fa";
// import { RiDeleteBin6Fill } from "react-icons/ri";

// export default function PaymentStructureTable() {
//   const API_BASE = process.env.REACT_APP_BASE_URL;
//   const { branchId } = useContext(CommonContext);

//   const [paymentData, setPaymentData] = useState({
//     allData: [],
//     pagination: { totalRecords: 0 }
//   });

//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const {
//     currentPage,
//     itemsPerPage,
//     handlePageChange,
//     handleItemsPerPageChange,
//     getPaginatedData,
//   } = usePagination(10);

//   const paginationData = getPaginatedData(paymentData);

//   // Fetch Payment Structure
//   useEffect(() => {
//     if (branchId) fetchPaymentStructure();
//   }, [currentPage, itemsPerPage, branchId]);

//   const fetchPaymentStructure = async () => {
//     try {
//       const res = await axios.get(
//         `${API_BASE}payment-structure/get-all?page=${currentPage}&limit=${itemsPerPage}&branchId=${branchId}`
//       );

//       if (res.data.success) {
//         setPaymentData({
//           allData: res.data.data,
//           pagination: res.data.pagination,
//         });
//       }
//     } catch (err) {
//       toast.error("Failed to fetch payment structure");
//     }
//   };

//   // Delete Payment Structure
//   const handleDelete = async (item) => {
//     try {
//       const res = await axios.post(`${API_BASE}payment-structure/delete?id=${item.id}`);

//       if (res.data.success) {
//         toast.success("Deleted successfully");
//         fetchPaymentStructure();
//       }
//     } catch {
//       toast.error("Failed to delete");
//     } finally {
//       setDeleteModal(false);
//       setSelectedPayment(null);
//     }
//   };

//   return (
//     <div className="p-4 flex justify-center">
//       <div className="w-full">
//         {/* Header */}
//         <div className="flex justify-between items-center bg-theme-bg text-theme-color px-3 py-2 rounded-t">
//           <h2 className="text-xl font-bold">Payment Structure</h2>
//           <AddButton text="+ Add" onClick={() => setIsAddModalOpen(true)} />
//         </div>

//         {/* Table */}
//         {paymentData.allData.length === 0 ? (
//           <p className="text-center text-gray-500 italic py-4">No data found</p>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full border border-gray-300 rounded">
//               <thead>
//                 <tr className="bg-theme-tableColumn text-center">
//                   <th className="border p-2">Sr.</th>
//                   <th className="border p-2">Name</th>
//                   <th className="border p-2">Name (Hindi)</th>
//                   <th className="border p-2">Type</th>
//                   <th className="border p-2">Ledger</th>
//                   <th className="border p-2">Group</th>
//                   <th className="border p-2">Subgroup</th>
//                   <th className="border p-2">Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginationData.currentItems.map((item, i) => (
//                   <tr key={item.id} className="text-center">
//                     <td className="border p-2">
//                       {(currentPage - 1) * itemsPerPage + i + 1}
//                     </td>

//                     <td className="border p-2">{item.name}</td>
//                     <td className="border p-2">{item.name_in_hindi}</td>
//                     <td className="border p-2">{item.type || "-"}</td>

//                     <td className="border p-2">{item.ledgerName}</td>
//                     <td className="border p-2">{item.groupName}</td>
//                     <td className="border p-2">{item.subGroupName}</td>

//                     <td className="border p-2">
//                       <div className="flex justify-center gap-3">
//                         <FaEdit
//                           className="cursor-pointer hover:text-theme-btnBg"
//                           onClick={() => {
//                             setSelectedPayment(item);
//                             setIsAddModalOpen(true);
//                           }}
//                         />

//                         <RiDeleteBin6Fill
//                           className="text-red-600 cursor-pointer hover:text-red-800"
//                           onClick={() => {
//                             setSelectedPayment(item);
//                             setDeleteModal(true);
//                           }}
//                         />
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination */}
//             <Pagination
//               data={paymentData}
//               currentPage={currentPage}
//               itemsPerPage={itemsPerPage}
//               onPageChange={handlePageChange}
//               onItemsPerPageChange={handleItemsPerPageChange}
//               itemsPerPageOptions={[10, 20, 50]}
//               showPageInfo
//             />
//           </div>
//         )}
//       </div>

//       {/* Add / Edit Modal */}
//       {isAddModalOpen && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//           <AddPayment
//             editData={selectedPayment}
//             onClose={() => {
//               setIsAddModalOpen(false);
//               setSelectedPayment(null);
//             }}
//             onSaveSuccess={fetchPaymentStructure}
//           />
//         </div>
//       )}

//       {/* Delete Modal */}
//       {deleteModal && (
//         <DeleteDataModal
//           selectedLedger={selectedPayment}
//           handleDeleteModalClose={() => setDeleteModal(false)}
//           handleDeleteLedgerApi={handleDelete}
//         />
//       )}
//     </div>
//   );
// }
